import React from 'react';
import PropTypes from 'prop-types';

// Inlined so fill="currentColor" can be driven by CSS (Isvg/img cannot do this reliably).
const SmartRateDemandUserIcon = ({ className }) => (
  <svg
    aria-hidden
    className={className}
    fill="none"
    height="27"
    viewBox="0 0 32 26.7373"
    width="32"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.7812 0C12.1478 0 9.20637 2.96951 9.20637 6.57534C9.16312 10.2236 12.1045 13.1507 15.7812 13.1507C19.4147 13.1507 22.3561 10.2236 22.3561 6.57534C22.3994 2.92709 19.458 0 15.7812 0Z"
      fill="currentColor"
    />
    <path
      d="M29.8003 26.7373C31.1932 26.7373 32.2267 25.5057 31.9571 24.1861C30.8787 19.5674 27.284 14.025 23.2401 14.025H8.77181C4.77281 14.025 1.13331 19.5674 0.0549296 24.1861C-0.259598 25.5057 0.818805 26.7373 2.21172 26.7373H29.8003Z"
      fill="currentColor"
    />
  </svg>
);

SmartRateDemandUserIcon.propTypes = {
  className: PropTypes.string,
};

SmartRateDemandUserIcon.defaultProps = {
  className: undefined,
};

export default SmartRateDemandUserIcon;
